import dynamic from "next/dynamic";
import RotatingTitleParagraphConfig from "./rotating-title-paragraph-config";
import RotatingTitleParagraphAdvancedConfig from "./rotating-title-paragraph-advanced-config";
const RotatingTitleParagraphComponent = dynamic(()=>import("./rotating-title-paragraph-component"));
export default {
    RotatingTitleParagraphComponent,
    RotatingTitleParagraphConfig,
    RotatingTitleParagraphAdvancedConfig
};
